
module.exports = {
	webp: require(`./imgop_WinterWheatStraw_StretchedTiff.webp`),
	jp2: require(`./imgop_WinterWheatStraw_StretchedTiff.jp2`),
	fallback: require(`./imgop_WinterWheatStraw_StretchedTiff.png`),
}
